var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube",
    clipPath: "url(#clip0_76_104589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6659 23.1115L12.4751 23.0348C11.1182 23.0081 9.75799 23.0614 8.42772 22.7847C6.40407 22.3713 6.26071 20.3443 6.11069 18.644C5.90399 16.2536 5.98401 13.8198 6.37409 11.4493C6.5943 10.1192 7.46092 9.32556 8.80112 9.2392C13.3253 8.92576 17.8795 8.96291 22.3936 9.10914C22.8704 9.12254 23.3504 9.19581 23.8205 9.27921C26.141 9.68597 26.1976 11.9831 26.348 13.9168C26.498 15.8705 26.4347 17.8342 26.148 19.7745C25.9179 21.3811 25.4778 22.7284 23.6205 22.8584C21.2933 23.0285 19.0196 23.1654 16.6858 23.1218C16.6859 23.1115 16.6725 23.1115 16.6659 23.1115ZM14.2021 19.0441C15.9558 18.0372 17.6761 17.047 19.4198 16.0469C17.6628 15.0399 15.9458 14.0498 14.2021 13.0496V19.0441Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_104589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2a546022b5db69fc476661658c7f6213.svg";
export { ForwardRef as ReactComponent };